var navigation = {

  // Variables
  toggleActiveClass: 'tcon-transform',
  navigationOpenClass: 'open',
  bodyNoScrollClass: 'noscroll',
  scrollTop: 0,
  touchEvent: ('ontouchstart' in window) ? "tap" : "click",
  siteNavOffsetTop: 50,
  isMobile: (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) ? true : false,

  iOSversion: function() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
      var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
  },

  // Cache the DOM
  cacheDom: function () {
    this.window = $(window)
    this.body = $('body')
    this.siteNav = $('.sitenav')
    this.siteNavToggler = $('.sitenav__toggle')
    this.searchToggler = $('.search-toggle')
    this.globalNav = $('.global-navigation')
    this.globalNavToggler = $('.global-nav-toggle, .global-nav-more, .global-nav-close')
	this.dropdownToggles = this.siteNav.find('.has-dropdown')
    this.linksInDropdowns = this.siteNav.find('.has-dropdown a')
    this.dropdownClose = this.siteNav.find('.dropdown__close')
	this.siteGroups = this.globalNav.find('[data-site-color]')
	this.preventToggling = false;
	
  },

  // Bind relevant events on our DOM elements to their desired functions
  bindEvents: function() {
	  var that = this;
    this.siteNavToggler.on('click tap', this.toggleSiteNav.bind(this))
    this.globalNavToggler.on('click', this.toggleGlobalNav.bind(this))
	this.dropdownToggles.on('click tap', this.toggleDropdown.bind(this))
	this.siteNav.on('click tap', '.has-dropdown a', this.goToLink.bind(this))
	this.siteNav.on('click tap', 'a.logo', this.goToLink.bind(this))
	this.siteNav.on('click tap', '.sitenav__link:not(.has-dropdown) > span > a', this.goToLink.bind(this))
	this.linksInDropdowns.on('click tap', this.goToLink.bind(this))
	this.dropdownToggles.on('mouseenter', function () {
		if ($(this).closest(".sitenav").hasClass("sitenav--nodrops") && !$(this).hasClass("secondary-nav"))
		{
			console.log("no drops");
			return;
		}
		$(this).addClass("hover");
	}).on('mouseleave', function () { $(this).removeClass("hover"); })
    this.dropdownClose.on('click', this.closeDropdown.bind(this));
	this.window.on('scroll', this.animateSiteNav.bind(this))
	this.siteNav.on(this.touchEvent, '[data-toggle=modal]', function () { $($(this).attr('href')).modal("show") });
	this.siteNav.on('tap', '[data-dismiss=modal]', function () { $(this).closest('.modal').modal("hide") });
	this.siteNav.on('tap', '.remove-prod', function () { $(this).trigger("click") });
  },

  goToLink: function (e) {
	  var elem = $(e.target);
	  if (elem.attr("target") == "_blank") {
		  return;
	  }
	  var gotoHref = elem.attr("href");
	  if (gotoHref === undefined) {
		  gotoHref = elem.parent().attr("href");
	  }
	  window.location.href = gotoHref;
  },

  // iOS9 ignores padding on the nav items which is annoying
  optimizeMobile: function () {
    if (this.window.width() > 1025)
      return

    var globalNavItems = this.globalNav.find('.global-navigation-featured li')

    // Remove the padding so we get an accurate reading of the span's width
    this.globalNav.find('.global-navigation-featured a, .global-navigation-featured button').css('padding', 0)
    
    globalNavItems.each(function () {
      // For some reason outerWidth is 12px off
      var width = $(this).find('a, button').outerWidth() + 12
      var spanWidth = $(this).find('span').outerWidth() + 12

      // Padding on each side equals 3rem
      var padding = 39 * 2

      // The width of the a tag should be equal to the width of the span plus the padding
      var desiredWidth = padding + spanWidth

      // If the a tags width doesn't match then we add min-width to it to fight iOS9
      if (width < desiredWidth)
        $(this).css('min-width', desiredWidth)
    })
  },

  // Open or close site nav on mobile devices
  toggleSiteNav: function () {
	  console.log("toggleSiteNav");
	  var that = this

	  if (!that.preventToggling) {
    if (this.globalNav.find('ul').scrollLeft() > 0) {
      this.globalNav.find('ul').scrollLeft(0)
    }

    this.globalNav.toggleClass('sitenav-is-open')
    this.siteNav.addClass('visible')
    this.siteNav.toggleClass(this.navigationOpenClass)
    this.siteNavToggler.toggleClass(this.toggleActiveClass)
    this.searchToggler.toggleClass('sitenav--is-open')

    // Prevent body scroll
	this.body.toggleClass(this.bodyNoScrollClass)
	  }

	  that.preventToggling = true;
	  setTimeout(function () {
		  that.preventToggling = false
	  }, 100)
  },

  // Open or close global nav on mobile and desktop devices
  toggleGlobalNav: function() {
    this.globalNav.toggleClass(this.navigationOpenClass)

    // Prevent body scroll
    this.body.toggleClass(this.bodyNoScrollClass)
  },

    // Toggle dropdowns on mobile devices
  toggleDropdown: function (e) {
	  console.log(e);
	  var that = this
      if (this.window.width() >= 1025)
          return
	  e.stopPropagation();
      var elem = $(e.target)
	  var dropdown = elem.siblings('.dropdown').length ? elem.siblings('.dropdown') : elem.find('.dropdown').first()
	  if (!that.preventToggling) {
		  dropdown.toggleClass('is-open')
		  elem.parent().toggleClass('is-active')
	  }

	  that.preventToggling = true;
	  setTimeout(function () {
		  that.preventToggling = false
	  }, 100)
  },

    // Toggle dropdowns on mobile devices
  closeDropdown: function (e) {

      var elem = $(e.target)
      var dropdown = elem.closest('.has-dropdown.hover').trigger('mouseleave');
  },

  addDropdownHover: function (e) {
      var elem = $(e.target);
      elem.addClass("hover");
  },

  removeDropdownHover: function (e) {
      var elem = $(e.target);
      elem.removeClass("hover");
  },

  // Apply background colors to links in site groups
  applySiteColor: function () {
    this.siteGroups.each(function (i, e) {
      var color = $(e).attr('data-site-color')
      $(e).find('a').css({
        backgroundColor: color,
        color: '#fff'
      })
    })
  },

  animateSiteNav: function () {
    var oldScrollTop = this.scrollTop
    var newScrollTop = this.window.scrollTop()
    var siteNavHeight = this.siteNav.outerHeight()
    var globalNavHeight = this.globalNav.find('.global-navigation-featured').outerHeight()
    var siteNavTop = parseInt(this.siteNav.css('top'), 10)
    var speed = 1

    // Check if the scroll direction is downwards or upwards
    // if false we can assume it's upwards
    var directionDown = newScrollTop > oldScrollTop

    var moveOverGlobalNav = newScrollTop < globalNavHeight
    var animateOut = directionDown && newScrollTop > globalNavHeight
    var animateIn = !directionDown && newScrollTop > globalNavHeight

    if (newScrollTop > globalNavHeight + siteNavHeight) {
      this.body.addClass('fixed-nav')
    }

    if (this.window.width() < 1024) {
      if (newScrollTop <= globalNavHeight + siteNavHeight) {
        this.body.removeClass('fixed-nav')
      }
    } else {
      if (newScrollTop <= globalNavHeight) {
        this.body.removeClass('fixed-nav')
      }
    }

    if (animateIn) {
      this.siteNav.addClass('visible')
    } else {
      this.siteNav.removeClass('visible')
    }

    // Update scrollTop variable when all is done
    this.scrollTop = newScrollTop
  },

  _animateSiteNav: function () {
    var oldScrollTop = this.scrollTop
    var newScrollTop = this.window.scrollTop()
    var siteNavHeight = this.siteNav.outerHeight()
    var globalNavHeight = this.globalNav.find('.global-navigation-featured').outerHeight()
    var siteNavTop = parseInt(this.siteNav.css('top'), 10)
    var speed = 1

    // Check if the scroll direction is downwards or upwards
    // if false we can assume it's upwards
    var directionDown = newScrollTop > oldScrollTop

    var scrolledOnMobile = newScrollTop > 0 && this.window.width() < 1024
    var moveOverGlobalNav = newScrollTop < globalNavHeight
    var animateOut = directionDown && newScrollTop > globalNavHeight
    var animateIn = !directionDown && newScrollTop > globalNavHeight && siteNavTop < 0

    if (moveOverGlobalNav) {
      this.siteNav.css('top', globalNavHeight - newScrollTop)
    }

    if (animateOut) {
      var top = siteNavTop - (newScrollTop - oldScrollTop) / speed
          top = top < -Math.abs(siteNavHeight) ? -Math.abs(siteNavHeight) : top
      this.siteNav.css('top', top)
    }

    if (animateIn) {
      var top = siteNavTop + (oldScrollTop - newScrollTop)
          top = top > 0 ? 0 : top
      this.siteNav.css('top', top)
    }

    if (scrolledOnMobile) {
      this.siteNav.addClass('scrolled')
    } else {
      this.siteNav.removeClass('scrolled')
    }

    // Update scrollTop variable when all is done
    this.scrollTop = newScrollTop
  },

  positionSiteNavOnLoad: function() {
    if (this.scrollTop > this.globalNav.outerHeight() + this.siteNav.outerHeight())
      this.siteNav.css('top', 0)
  },

  // Inititate the module
  init: function() {
    this.cacheDom()
    this.applySiteColor()
    this.optimizeMobile()
    this.bindEvents()

    // Update scrollTop and siteNavOffsetTop variables as soon as the page loads
    this.scrollTop = this.window.scrollTop()
    // this.positionSiteNavOnLoad()
  }

}

$(document).ready(function() { navigation.init();console.log("navigation");} );
